// InsuranceClaimsTab.tsx — Admin Panel -> Insurance Claims. Five sub-tabs
// (Payers, Service Master, Branch Claims Profile, Document Rules, Payer
// Tariffs & Packages — Phase 4.5.7 added Service Master, Phase 5.4 added
// Document Rules, Phase 6.1 adds Payer Tariffs & Packages, wireframe S9's
// 3rd tab), same pattern the SMS Gateway tab already uses for its own
// sub-sections.
import AdminTabs from '../AdminTabs';
import { useAdminSubTab } from '../adminRoute';
import PayersTab from './PayersTab';
import BranchClaimProfileTab from './BranchClaimProfileTab';
import ServiceMasterTab from './ServiceMasterTab';
import DocumentRulesTab from './DocumentRulesTab';
import PayerTariffsPackagesTab from './PayerTariffsPackagesTab';

export default function InsuranceClaimsTab() {
  const tabs = useAdminSubTab('insurers');
  const tab = tabs.active;

  return (
    <div className="fade-in">
      <AdminTabs state={tabs} />
      {tab === 'payers' && <PayersTab />}
      {tab === 'service-master' && <ServiceMasterTab />}
      {tab === 'branch-profile' && <BranchClaimProfileTab />}
      {tab === 'document-rules' && <DocumentRulesTab />}
      {tab === 'tariffs-packages' && <PayerTariffsPackagesTab />}
    </div>
  );
}
